import { AnyAppEvent, AppEvent } from "../appEvent.types";

const eventName = "ticket-alert-threshold" as const;

export type TicketAlertThresholdEventData = {
  eventId: string;
  ticketTypeId: string;
  ticketTypeName: string;
  quantityLeft: number;
  alertThreshold: number;
};

export type TicketAlertThresholdEvent = AppEvent<
  typeof eventName,
  TicketAlertThresholdEventData
>;

export const isTicketAlertThresholdEvent = (
  event: AnyAppEvent
): event is TicketAlertThresholdEvent => event.name === eventName;

export { eventName as ticketAlertThreshold };
